import { render, staticRenderFns } from "./GenerateBacsPaymentsModal.vue?vue&type=template&id=57cff77a"
import script from "./GenerateBacsPaymentsModal.vue?vue&type=script&lang=js"
export * from "./GenerateBacsPaymentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports